import TiltMessage from "../../../components/feedback/TiltMessage";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { SectionHeader } from "../../SectionHeader";
import { WholesaleAOVFrequency } from "../components/wholesale-AOV";
import { WholesaleCustomerSales } from "../components/wholesale-customerSales";
import { WholesaleCustomerSegmentation } from "../components/wholesale-CustomerSegment";




export function WholesaleCustomer() {
    const showTiltMessage = useIsPortraitMobile();


    return (
        <>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="Customer Insights" />
                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                        <WholesaleCustomerSegmentation />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <WholesaleAOVFrequency />
                    </div>
                    <div className="col-span-6 flex flex-col h-full">
                        <WholesaleCustomerSales />
                    </div>
                </ModuleGrid>
            </div>
        </>
    )
}